import { FilePreviewWithIpAddress } from 'models/File';
import httpClient from '../httpClient';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';

function getShareableLinkDocuments(shareableLinkId: string, parentId?: string) {
  return httpClient.get<DataRoomNode[]>(
    `shareable-links/${shareableLinkId}/parent-nodes`,
    {
      params: { parentId },
    },
  );
}

function getFolderPath(shareableLinkId: string, documentId: string) {
  return httpClient.get<Array<DataRoomNode>>(
    `shareable-links/${shareableLinkId}/data-room-nodes/${documentId}/node-path`,
  );
}

function getFileBufferPreview(shareableLinkId: string, dataRoomNodeId: string) {
  return httpClient.get<FilePreviewWithIpAddress>(
    `shareable-links/${shareableLinkId}/data-room-nodes/${dataRoomNodeId}/file-buffer-preview`,
  );
}

function bulkDownload(
  shareableLinkId: string,
  dataRoomNodeIds: string[],
  name: string,
  uniqueId: string,
) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/file-buffer-download-bulk`,
    {
      dataRoomNodeIds,
      name,
      uniqueId,
    },
  );
}

function startDownloadingFile(
  shareableLinkId: string,
  dataRoomNodeId: string,
  uniqueId: string,
) {
  return httpClient.get(
    `shareable-links/${shareableLinkId}/data-room-nodes/${dataRoomNodeId}/file-buffer-download`,
    {
      params: { uniqueId },
    },
  );
}

function trackTime(
  shareableLinkId: string,
  nodeId: string,
  pageIndex: number,
  numberOfSecondsSpent: number,
  version?: number,
) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/data-room-nodes/${nodeId}/track-time`,
    { pageIndex, numberOfSecondsSpent, version },
  );
}

export default {
  getShareableLinkDocuments,
  getFolderPath,
  getFileBufferPreview,
  bulkDownload,
  startDownloadingFile,
  trackTime,
};
